define("auth/components/login-form", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "shared/utils/redirect", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _redirect, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _clearPassword, _trackUserLogin, _createQueryStringFromCurrentURL;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"shared/utils/redirect",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! Login Page }}
  <div class="tSU--container" data-test-id="login-form-template">
    {{! Cards }}
    <div class="tSU--container__row">
      {{! Campaign details }}
      {{#if this.isCampaignLogin}}
        <CampaignDetails @campaign={{this.campaign}} />
      {{/if}}
  
      {{! Card }}
      <div class="tSU--card">
        {{#if this.isCampaignLogin}}
          {{! TODO: Insert Later x Mavrck image }}
          <div class="img--logo" />
        {{/if}}
        <h1 class="tSU--card__title">{{this.title}}</h1>
        {{#if this.subtitle}}
          <p class="tSU--card__subtitle u--text--light u--m__t__xs u--m__b__0">
            {{this.subtitle}}
            {{! TODO: Update link before release}}
            <Shared::Link
              @class="u--text--hl"
              @href="https://www.later.com/"
              @text={{t "shared_phrases.learn_more"}}
              @type="unstyled"
            />
          </p>
        {{/if}}
  
        {{#if (and this.isCampaignLogin this.auth.isKeycloak)}}
          <br />
          <Shared::Ui::Button
            @additional="block"
            @onClick={{this.openKeycloak}}
            @size="large"
            @text={{t "authorization.sign_in"}}
            class="u--m__b__lg"
          />
          <div class="u--p__tb__lg"></div>
          <div class="u--p__tb__lg"></div>
          <div class="u--p__tb__lg"></div>
          <div class="u--p__tb__lg"></div>
  
        {{else}}
          {{! Form Objects }}
          <form
            class="u--p__t__lg"
            {{on "submit" (perform this.login this.identification this.password this.twoFactorCode)}}
          >
            <div class="o--formWrapper--lg dd-privacy-mask-user-input">
              <label>{{t "shared_words.email"}} </label>
              <Input
                @type="email"
                @value={{this.identification}}
                autocomplete="username"
                class="form-control o--form__input qa--signin_email_input"
                disabled={{this.twoFactorEnabled}}
                placeholder={{t "authorization.sign_in_form.email_placeholder"}}
                {{autofocus}}
              />
            </div>
            {{! Password }}
            <Shared::Credentials::PasswordInput
              @dataTestID="login-password-input"
              @password={{this.password}}
              @qaClassName="signin_password_input"
            />
  
            {{#if this.twoFactorEnabled}}
              <div class="o--formWrapper--lg">
                <label>{{t "authorization.sign_in_form.2fa_input_label"}}</label>
                <Input
                  @type="text"
                  @value={{this.twoFactorCode}}
                  class="form-control o--form__input qa--signin_2fa_input"
                  placeholder={{t "authorization.sign_in_form.2fa_input_placeholder"}}
                  {{autofocus}}
                />
              </div>
            {{/if}}
  
            <div class="o--formSubmit">
              <Shared::Ui::Button
                @additional="block"
                @isDisabled={{this.isLoginDisabled}}
                @size="large"
                @text={{t "authorization.sign_in"}}
                class="qa--login__btn"
                data-test-id="login-form-submit-button"
                type="submit"
              />
            </div>
          </form>
        {{/if}}
  
        {{! Show powered by later if on campaign login  }}
        {{#if this.isCampaignLogin}}
          <p class="u--text--right u--m__b__lg u--m__t">
            {{t "authorization.sign_in_campaign_form.powered_by"}}
          </p>
        {{/if}}
  
        <p class="u--text--center u--m__b__lg u--m__t">
          {{if
            @isSsoLogin
            (t "authorization.new_to_later_sso_long" ssoAppName=@ssoAppName)
            (t "authorization.new_to_later")
          }}
          {{#if this.isCampaignLogin}}
            <LinkTo @route="campaign.signup" class="u--p__l__xs qa--createAccount_link">
              {{html-safe (t "authorization.create_an_account")}}
            </LinkTo>
          {{else}}
            <LinkTo @query={{this.searchParams}} @route="signup" class="u--p__l__xs qa--createAccount_link">
              {{html-safe (t "authorization.create_an_account")}}
            </LinkTo>
          {{/if}}
        </p>
  
        {{! Forgot Password }}
        <div class="u--row u--p__t__lg">
          <LinkTo
            @route="reset_password"
            class="u--text--light u--text--underline u--text--sm u--block u--block u--col__6"
          >
            {{t "authorization.sign_in_form.forgot_password"}}
          </LinkTo>
          <a
            class="u--text--light u--text--underline u--text--sm u--block u--col__6"
            {{on "click" (toggle-action "showIgHelp" this)}}
          >
            {{t "authorization.sign_in_form.sign_in_ig"}}
          </a>
          {{#if this.showIgHelp}}
            <div class="u--col__12 u--fadeIn u--clearfix">
              <p class="u--p__t__xs u--m__b u--text--sm">{{t "authorization.sign_in_form.sign_in_ig_answer"}}</p>
              <LinkTo @route="forgot_email" class="u--text--light u--text--underline u--text--sm u--block u--m__t__xs">
                {{t "authorization.forgot_email"}}
              </LinkTo>
            </div>
          {{/if}}
        </div>
      </div>
  
      {{! NOTE: Only show the feature card if the user is not logging in from a campaign. }}
      {{#unless this.isCampaignLogin}}
        {{! Feature Card }}
        <div class="tSU--card tSU--card--featured">
          {{!-- <p class="tSU--card__title--featured u--m__b__sm">{{html-safe (t "authorization.sign_in_banner.title")}}</p>
          <Shared::Link
            @href="https://later.com/content-creators/?utm_source=sign-in-banner&utm_campaign=gtm_creator_lens"
            class="u--text--white u--text--base"
          >
            {{t "shared_phrases.learn_more"}}
          </Shared::Link>
          <Shared::Link @href="https://www.later.com/training">
            <img class="tSU--card__image" src="/assets/images/img--signIn--featured--fg.png" />
          </Shared::Link> --}}
        </div>
      {{/unless}}
    </div>
  </div>
  
  {{! Successful / Get started }}
  <div class="tSU--container u--hide">
    {{! Card }}
    <div class="tSU--card">
      <h1 class="tSU--card__title">{{t "authorization.get_started.title"}}</h1>
      <p class="u--text--md u--m__b__lg">{{t "authorization.get_started.sub_title"}}</p>
      <Shared::Ui::Button
        @additional="block"
        @size="large"
        @text={{t "authorization.get_started.calendar"}}
        class="u--m__b u--m__t__lg"
      />
      <Shared::Ui::Button
        @additional="block"
        @size="large"
        @text={{t "authorization.get_started.rewards"}}
        @variant="outline"
      />
    </div>
  </div>
  */
  {
    "id": "2pUcVf7F",
    "block": "[[[10,0],[14,0,\"tSU--container\"],[14,\"data-test-id\",\"login-form-template\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tSU--container__row\"],[12],[1,\"\\n\"],[41,[30,0,[\"isCampaignLogin\"]],[[[1,\"      \"],[8,[39,1],null,[[\"@campaign\"],[[30,0,[\"campaign\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n\"],[41,[30,0,[\"isCampaignLogin\"]],[[[1,\"        \"],[10,0],[14,0,\"img--logo\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,\"h1\"],[14,0,\"tSU--card__title\"],[12],[1,[30,0,[\"title\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"subtitle\"]],[[[1,\"        \"],[10,2],[14,0,\"tSU--card__subtitle u--text--light u--m__t__xs u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,0,[\"subtitle\"]]],[1,\"\\n\"],[1,\"          \"],[8,[39,2],null,[[\"@class\",\"@href\",\"@text\",\"@type\"],[\"u--text--hl\",\"https://www.later.com/\",[28,[37,3],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"isCampaignLogin\"]],[30,0,[\"auth\",\"isKeycloak\"]]],null],[[[1,\"        \"],[10,\"br\"],[12],[13],[1,\"\\n        \"],[8,[39,5],[[24,0,\"u--m__b__lg\"]],[[\"@additional\",\"@onClick\",\"@size\",\"@text\"],[\"block\",[30,0,[\"openKeycloak\"]],\"large\",[28,[37,3],[\"authorization.sign_in\"],null]]],null],[1,\"\\n        \"],[10,0],[14,0,\"u--p__tb__lg\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--p__tb__lg\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--p__tb__lg\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--p__tb__lg\"],[12],[13],[1,\"\\n\\n\"]],[]],[[[1,\"        \"],[11,\"form\"],[24,0,\"u--p__t__lg\"],[4,[38,6],[\"submit\",[28,[37,7],[[30,0,[\"login\"]],[30,0,[\"identification\"]],[30,0,[\"password\"]],[30,0,[\"twoFactorCode\"]]],null]],null],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper--lg dd-privacy-mask-user-input\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,3],[\"shared_words.email\"],null]],[1,\" \"],[13],[1,\"\\n            \"],[8,[39,8],[[24,\"autocomplete\",\"username\"],[24,0,\"form-control o--form__input qa--signin_email_input\"],[16,\"disabled\",[30,0,[\"twoFactorEnabled\"]]],[16,\"placeholder\",[28,[37,3],[\"authorization.sign_in_form.email_placeholder\"],null]],[4,[38,9],null,null]],[[\"@type\",\"@value\"],[\"email\",[30,0,[\"identification\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"],[1,\"          \"],[8,[39,10],null,[[\"@dataTestID\",\"@password\",\"@qaClassName\"],[\"login-password-input\",[30,0,[\"password\"]],\"signin_password_input\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"twoFactorEnabled\"]],[[[1,\"            \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n              \"],[10,\"label\"],[12],[1,[28,[35,3],[\"authorization.sign_in_form.2fa_input_label\"],null]],[13],[1,\"\\n              \"],[8,[39,8],[[24,0,\"form-control o--form__input qa--signin_2fa_input\"],[16,\"placeholder\",[28,[37,3],[\"authorization.sign_in_form.2fa_input_placeholder\"],null]],[4,[38,9],null,null]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"twoFactorCode\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[10,0],[14,0,\"o--formSubmit\"],[12],[1,\"\\n            \"],[8,[39,5],[[24,0,\"qa--login__btn\"],[24,\"data-test-id\",\"login-form-submit-button\"],[24,4,\"submit\"]],[[\"@additional\",\"@isDisabled\",\"@size\",\"@text\"],[\"block\",[30,0,[\"isLoginDisabled\"]],\"large\",[28,[37,3],[\"authorization.sign_in\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,0,[\"isCampaignLogin\"]],[[[1,\"        \"],[10,2],[14,0,\"u--text--right u--m__b__lg u--m__t\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"authorization.sign_in_campaign_form.powered_by\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,2],[14,0,\"u--text--center u--m__b__lg u--m__t\"],[12],[1,\"\\n        \"],[1,[52,[30,1],[28,[37,3],[\"authorization.new_to_later_sso_long\"],[[\"ssoAppName\"],[[30,2]]]],[28,[37,3],[\"authorization.new_to_later\"],null]]],[1,\"\\n\"],[41,[30,0,[\"isCampaignLogin\"]],[[[1,\"          \"],[8,[39,11],[[24,0,\"u--p__l__xs qa--createAccount_link\"]],[[\"@route\"],[\"campaign.signup\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,12],[[28,[37,3],[\"authorization.create_an_account\"],null]],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[39,11],[[24,0,\"u--p__l__xs qa--createAccount_link\"]],[[\"@query\",\"@route\"],[[30,0,[\"searchParams\"]],\"signup\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,12],[[28,[37,3],[\"authorization.create_an_account\"],null]],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\\n\"],[1,\"      \"],[10,0],[14,0,\"u--row u--p__t__lg\"],[12],[1,\"\\n        \"],[8,[39,11],[[24,0,\"u--text--light u--text--underline u--text--sm u--block u--block u--col__6\"]],[[\"@route\"],[\"reset_password\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,3],[\"authorization.sign_in_form.forgot_password\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[11,3],[24,0,\"u--text--light u--text--underline u--text--sm u--block u--col__6\"],[4,[38,6],[\"click\",[28,[37,13],[\"showIgHelp\",[30,0]],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"authorization.sign_in_form.sign_in_ig\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"showIgHelp\"]],[[[1,\"          \"],[10,0],[14,0,\"u--col__12 u--fadeIn u--clearfix\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--p__t__xs u--m__b u--text--sm\"],[12],[1,[28,[35,3],[\"authorization.sign_in_form.sign_in_ig_answer\"],null]],[13],[1,\"\\n            \"],[8,[39,11],[[24,0,\"u--text--light u--text--underline u--text--sm u--block u--m__t__xs\"]],[[\"@route\"],[\"forgot_email\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,3],[\"authorization.forgot_email\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"isCampaignLogin\"]]],[[[1,\"      \"],[10,0],[14,0,\"tSU--card tSU--card--featured\"],[12],[1,\"\\n\"],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tSU--container u--hide\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n    \"],[10,\"h1\"],[14,0,\"tSU--card__title\"],[12],[1,[28,[35,3],[\"authorization.get_started.title\"],null]],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md u--m__b__lg\"],[12],[1,[28,[35,3],[\"authorization.get_started.sub_title\"],null]],[13],[1,\"\\n    \"],[8,[39,5],[[24,0,\"u--m__b u--m__t__lg\"]],[[\"@additional\",\"@size\",\"@text\"],[\"block\",\"large\",[28,[37,3],[\"authorization.get_started.calendar\"],null]]],null],[1,\"\\n    \"],[8,[39,5],null,[[\"@additional\",\"@size\",\"@text\",\"@variant\"],[\"block\",\"large\",[28,[37,3],[\"authorization.get_started.rewards\"],null],\"outline\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@isSsoLogin\",\"@ssoAppName\"],false,[\"if\",\"campaign-details\",\"shared/link\",\"t\",\"and\",\"shared/ui/button\",\"on\",\"perform\",\"input\",\"autofocus\",\"shared/credentials/password-input\",\"link-to\",\"html-safe\",\"toggle-action\",\"unless\"]]",
    "moduleName": "auth/components/login-form.hbs",
    "isStrictMode": false
  });
  let LoginFormComponent = _exports.default = (_class = (_clearPassword = /*#__PURE__*/new WeakSet(), _trackUserLogin = /*#__PURE__*/new WeakSet(), _createQueryStringFromCurrentURL = /*#__PURE__*/new WeakSet(), class LoginFormComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _createQueryStringFromCurrentURL);
      _classPrivateMethodInitSpec(this, _trackUserLogin);
      _classPrivateMethodInitSpec(this, _clearPassword);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "showIgHelp", _descriptor4, this);
      _initializerDefineProperty(this, "twoFactorCode", _descriptor5, this);
      _initializerDefineProperty(this, "password", _descriptor6, this);
      _defineProperty(this, "login", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (identification, password, otp_attempt, event) {
          event.preventDefault();
          if (this.isCampaignLogin) {
            _classPrivateMethodGet(this, _trackUserLogin, _trackUserLogin2).call(this);
          }
          yield this.auth.login(identification, password, otp_attempt, _classPrivateMethodGet(this, _clearPassword, _clearPassword2).bind(this));
        }
      }), null, "login", "drop"));
    }
    get searchParams() {
      const searchParams = new URLSearchParams(window.location.search);
      return Object.fromEntries(searchParams.entries());
    }
    get isLoginDisabled() {
      return this.args.authenticate.lastSuccessful || this.login.isRunning;
    }
    get twoFactorEnabled() {
      return this.auth.twoFactorEnabled;
    }
    get campaign() {
      return this.args.campaign;
    }
    get isCampaignLogin() {
      return !!this.campaign;
    }
    get subtitle() {
      if (this.isCampaignLogin) {
        return this.intl.t('authorization.sign_in_campaign_form.subtitle');
      }
      return undefined;
    }
    get title() {
      if (this.isCampaignLogin) {
        return this.intl.t('authorization.sign_in_campaign_form.title');
      }
      return this.intl.t('authorization.sign_in_form.title');
    }
    openKeycloak() {
      const queryParamString = _classPrivateMethodGet(this, _createQueryStringFromCurrentURL, _createQueryStringFromCurrentURL2).call(this);
      const baseUrl = `oauth/keycloak?campaign_id=${this.campaign?.slug}`;
      const url = queryParamString ? `${baseUrl}&${queryParamString}` : baseUrl;
      (0, _redirect.default)(url, true);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showIgHelp", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "twoFactorCode", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "password", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openKeycloak", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openKeycloak"), _class.prototype)), _class);
  function _clearPassword2() {
    this.password = '';
  }
  function _trackUserLogin2() {
    if (this.campaign) {
      this.segment.track('signed-in-account', {
        signup_source: 'mavrck_campaign_invite',
        campaign_name: this.campaign.name,
        brand_name: this.campaign.brand_name,
        campaign_id: this.campaign.slug
      });
    }
  }
  function _createQueryStringFromCurrentURL2() {
    const url = new URL(window.location.href);
    const {
      searchParams
    } = url;
    const queryString = searchParams.toString();
    return queryString;
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LoginFormComponent);
});